import React from 'react'

export const Clock = ({ color }: { color?: string }) => {
  return (
    <svg
      width='19'
      height='19'
      viewBox='0 0 19 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.80957 10.8268C5.49149 10.8268 5.25293 10.5882 5.25293 10.2701C5.25293 9.96003 5.49149 9.72144 5.80957 9.72144H9.41182V4.91051C9.41182 4.60038 9.65041 4.36182 9.96051 4.36182C10.2706 4.36182 10.5171 4.60038 10.5171 4.91051V10.2701C10.5171 10.5882 10.2706 10.8268 9.96051 10.8268H5.80957ZM9.96845 18.079C14.4057 18.079 18.0795 14.3973 18.0795 9.96797C18.0795 5.53076 14.3978 1.85693 9.96051 1.85693C5.53125 1.85693 1.85742 5.53076 1.85742 9.96797C1.85742 14.3973 5.5392 18.079 9.96845 18.079Z'
        fill={color ?? 'white'}
      />
    </svg>
  )
}
